import { get } from "lodash";
import React from "react";
import MainLoader from './MainLoader.jsx';
import Spinner from "react-bootstrap/Spinner";
import "./custom-components.style.scss";


const ModuleLoader = () => {
  return (
    <div className="wrapper_jr">
      <div className="loader_overlay">
        <div className="page_loader">
        <Spinner animation="border" variant="primary" />
        </div>
      </div>
    </div>
  );
};
const Container = () => {
  const mainLoaderUrls = ["/", "/auth", "/logout", "/auth?logout"];
  const location = window.location;
  const pathName = get(location, "pathname", "/");
  let index = mainLoaderUrls.indexOf(pathName);
  return index !== -1 ? <MainLoader /> : <ModuleLoader />;
};

export default Container;



